import React, { useState } from 'react';
import './Main.css';
import logo from '../assets/ctrl4.png';
import { useNavigate } from "react-router-dom";

function Main() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const handleSearch = async (e) => {
    e.preventDefault();
      if (query.trim()) {
      navigate(`/profile/${encodeURIComponent(query)}`);
      }
  };


  return (
    <div className="container">
      <div className="logo-box">
        <img src={logo} alt="ctrl4.gg" />
      </div>
      <div className="search-box">
        <form onSubmit={handleSearch}>
          <input
            type="text"
            name="userId"
            placeholder="소환사이름#태그"
            value={query} // input의 value 값을 React 상태인 query로 연결
            onChange={(e) => setQuery(e.target.value)} // onChange 이벤트 발생시, setQuery를 통해서 변경된 값을 받아 상태 업데이트
          />
          <button type="submit">검색</button>
        </form>
      </div>
    </div>
  );
}

export default Main;
